import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "./cart";
import modalsSlice from "./modals";

const store = configureStore({
    reducer: {
        cart: cartSlice.reducer,
        modals: modalsSlice.reducer
    }
});

export default store;